<script lang="ts">
  import { page } from '$app/stores';
  import { env } from '$env/dynamic/public';
  import { onMount } from 'svelte';
  import { getClientLocation } from 'core-components';
  import { getCookie } from '$helpers/CookiesHelper';

  let triggeredUserLeftEvent = false;
  let clientLocation;

  //start time counter for measuring time on page
  let startDate = new Date();

  function trackUrlMarketing(eventType: string = 'page_load') {
    let endDate = new Date();
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const totalSeconds = Math.floor((end - start) / 1000);

    try {
      fetch(`${env.PUBLIC_API_URL}/public/marketing/url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          visitorId: btoa(clientLocation?.ip),
          lpkey: $page.data.businessIdentifier,
          pagename: $page.data.pageIdentifier,
          completedUrl: window.location.href,
          eventType,
          userAgent: window.navigator.userAgent,
          ip: clientLocation?.ip,
          clarityId: getCookie('_clck'),
          timeOnPage: totalSeconds,
        }),
      });
    } catch (err) {
      console.log(err);
    }
  }
  function scrollToSection() {
    try {
      // Parse URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      // Get the "section" parameter from the URL
      const section = urlParams.get('section');
      // Scroll to the corresponding section if it exists
      if (section) {
        const targetSection = document.getElementById(section);
        if (targetSection) {
          targetSection.scrollIntoView();
        }
      }
    } catch (err) {}
  }

  onMount(async () => {
    //Get user location
    clientLocation = await getClientLocation();

    //Generate Vistor ID and save in cookies

    //Scroll to the spefefied section section=
    scrollToSection();

    // Add Eruda, inspect tools for development only if param is present
    if ($page.url.searchParams.get('vlt_testing')) {
      const eruda = (await import('eruda')).default;
      eruda.init();
    }

    if (
      $page.data.pageType === 'marketing' &&
      window.location.search.length > 0
    ) {
      trackUrlMarketing();
      document.addEventListener('click', event => {
        event.stopPropagation();
        try {
          //If an anchor tag is clicked and the href contains tel:
          if (
            event.target.tagName === 'A' &&
            event.target.href.includes('tel:')
          ) {
            trackUrlMarketing('click_to_call');
          } else if (
            event.target.tagName === 'A' &&
            event.target.href.includes('sms:')
          ) {
            trackUrlMarketing('click_to_sms');
          }
        } catch (err) {
          console.log(err);
        }
      });

      //Triger visitor left marketing event when the user leaves the apge.
      document.addEventListener('visibilitychange', function logData() {
        if (document.visibilityState === 'hidden' && !triggeredUserLeftEvent) {
          trackUrlMarketing('page_leave');
          triggeredUserLeftEvent = true;
        }
      });
      window.addEventListener('beforeunload', ev => {
        if (!triggeredUserLeftEvent) {
          trackUrlMarketing('page_leave');
          triggeredUserLeftEvent = true;
        }
      });
    }
  });
</script>

<slot />
